import { render, staticRenderFns } from "./AtomBadge.vue?vue&type=template&id=2385ec8a"
import script from "./AtomBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./AtomBadge.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports